import FindLocationResultState from '../data/schema/FindLocationResultState';
import resetFindLocationState from './resetFindLocationState';
import { action } from 'satcheljs/lib/legacy';
import { isNullOrWhiteSpace } from 'owa-string-utils';

/**
 * Action to show or hide the location find results drop down
 * @param findLocationResultState: the location well
 * @param shouldShowFindResult: if true then show the drop down
 * @param shouldClearFindResult: if true then clear the find location result set
 */
export default action('showHideFindResult')(function showHideFindResult(
    findLocationResultState: FindLocationResultState,
    shouldShowFindResult: boolean,
    shouldClearFindResult?: boolean
) {
    let findResultCount = findLocationResultState.findResultSet
        ? findLocationResultState.findResultSet.length
        : 0;
    findLocationResultState.findResultHightlightIndex = -1;

    if (shouldClearFindResult && findResultCount) {
        // Clear existing find result if are not explicitly preserving the result.
        resetFindLocationState(findLocationResultState);
    }

    // Highlight the first element of the drop down if we are showing the drop down and we either "use this location"
    // element. "use this location" is present if we have a query string
    if (shouldShowFindResult && !isNullOrWhiteSpace(findLocationResultState.queryString)) {
        findLocationResultState.findResultHightlightIndex = 0;
    }

    findLocationResultState.shouldShowFindResult = shouldShowFindResult;
});
